// Import Olympe runtime or DRAW
import 'olympe';

// Import project bricks (we use webpack-import-glob-loader to import all bricks)
;
import './web/QRScanner.js'; import './web/QRViewer.js';

